import { TFunction } from 'i18next';
import { TableColumn, TableStyles } from 'react-data-table-component';
import { WorkRecord } from 'src/api/wa/store/models/product/WaProduct';
import { formatJpnDate } from 'src/common/formatJpnDate/formatJpnDate';

export const productTableStyle: TableStyles = {
  table: {
    style: {
      backgroundColor: '#f8f8f8',
      borderTop: '2px solid #c026d3',
      padding: '0.5rem',
      borderRadius: '0.25rem',
    },
  },
  headCells: {
    style: {
      backgroundColor: '#f2f3f3',
      borderInline: '1px solid #e3e6e7',
      borderTop: '1px solid #e3e6e7',
      fontWeight: 700,
    },
  },
  rows: {
    style: {
      borderRight: '1px solid #e3e6e7',
      borderBottom: '1px solid #e3e6e7',
      borderLeft: '1px solid #e3e6e7',
    },
  },
};

export const productWorkRecordsColumns = (t: TFunction): TableColumn<WorkRecord>[] => {
  return [
    {
      id: 'kojUserId',
      name: t('wards.productDetails.history.workerId'),
      selector: (row) => row.kojUserId ?? '-',
      sortable: true,
      grow: 1,
    },
    {
      id: 'kojUserName',
      name: t('wards.productDetails.history.workerName'),
      selector: (row) => row.kojUserName ?? '-',
      sortable: true,
      grow: 1,
    },
    {
      id: 'sgyoName',
      name: t('wards.productDetails.history.jobName'),
      selector: (row) => row.sgyoName ?? '-',
      sortable: true,
      grow: 1,
    },
    {
      id: 'sgyoDate',
      name: t('wards.productDetails.history.jobDate'),
      selector: (row) => {
        if (!row.sgyoDate) return '-';
        const formatted = formatJpnDate({ iso: row.sgyoDate });
        return formatted.split(' ')[0];
      },
      sortable: true,
      grow: 1,
    },
    {
      id: 'sgyoComment',
      name: t('wards.productDetails.history.jobContent'),
      selector: (row) => row.sgyoComment ?? '-',
      sortable: true,
      grow: 1,
    },
  ];
};
